var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var ApiHttp = /** @class */ (function () {
    function ApiHttp(httpAdapter) {
        this.httpAdapter = httpAdapter;
    }
    ApiHttp.prototype.fetch = function (request, pagination) {
        var params = pagination
            ? __assign({ limit: pagination.limit, offset: pagination.offset }, request.params) : request.params;
        return this.httpAdapter.get(request.endpoint, {
            params: params,
            isGaf: request.isGaf,
        });
    };
    ApiHttp.prototype.post = function (request) {
        var body = __assign({}, request.payload, request.params);
        var options = {
            isGaf: request.isGaf,
            serializeBody: request.asFormData,
        };
        return this.httpAdapter.post(request.endpoint, body, options);
    };
    ApiHttp.prototype.put = function (request) {
        var body = __assign({}, request.payload, request.params);
        var options = {
            isGaf: request.isGaf,
            serializeBody: request.asFormData,
        };
        return this.httpAdapter.put(request.endpoint, body, options);
    };
    ApiHttp.prototype.delete = function (request) {
        return this.httpAdapter.delete(request.endpoint, {
            isGaf: request.isGaf,
        });
    };
    return ApiHttp;
}());
export { ApiHttp };
